export default "__VITE_ASSET__D4K3TJAV__"